"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DraggableBoardItemWithSubTask = exports.BoardItemWithSubTask = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@dnd-kit/core");
const core_2 = require("@material-ui/core");
const BoardItem_1 = __importStar(require("./BoardItem"));
const StyledCard = (0, styled_components_1.default)(core_2.Card) `
  cursor: pointer;
  overflow-y: auto;
  margin-bottom: 10px;
  background-color: #e6e6e6;
  &.dragging {
    opacity: 0.75;
  }
  .title {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .container {
    padding-left: 10px;
    padding-right: 10px;
  }
  .task-card {
    margin-bottom: 10px;
  }
`;
const BoardItemWithSubTask = props => {
    const { task, isLoading, isDragging } = props, cardProps = __rest(props, ["task", "isLoading", "isDragging"]);
    const classes = ['task-card-with-subtask'];
    isDragging && classes.push('dragging');
    const children = task.children || [];
    return (react_1.default.createElement(StyledCard, Object.assign({}, cardProps, { className: classes.join(' ') }),
        isLoading && react_1.default.createElement(core_2.LinearProgress, null),
        react_1.default.createElement("div", { className: 'title container' },
            react_1.default.createElement(core_2.Typography, { variant: 'body1' }, task.name)),
        children.length > 0 && (react_1.default.createElement("div", { className: 'container' }, children.map(subTask => (react_1.default.createElement(BoardItem_1.default, { isSubTask: true, task: subTask, key: subTask.id }))))),
        react_1.default.createElement(core_2.Divider, null),
        react_1.default.createElement(BoardItem_1.BoardItemInfo, { task: task })));
};
exports.BoardItemWithSubTask = BoardItemWithSubTask;
exports.default = exports.BoardItemWithSubTask;
const DraggableBoardItemWithSubTask = props => {
    const { task } = props;
    const { attributes, isDragging, listeners, setNodeRef } = (0, core_1.useDraggable)({
        id: task.id.toString()
    });
    return (react_1.default.createElement(exports.BoardItemWithSubTask, Object.assign({}, props, attributes, listeners, { innerRef: setNodeRef, isDragging: isDragging })));
};
exports.DraggableBoardItemWithSubTask = DraggableBoardItemWithSubTask;
//# sourceMappingURL=BoardItemWithSubTask.js.map